module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAsElEQVR4AWJwL/AhiIGAGYg5QRgIeJAxTBzQbR1YAAxDQQBFQYbqbB0hQwQha3Svqk9QHO47yVEEqD4nyc/FN8y/CGgixGJgHUrCEMsjeCE0iemojrEoAMtCsHxBKl2t9RxjPL33W0lJp2utXQFilE+Z2ruARPTA6RahYfGgjE4wi6noBHU0DtVPQH0f9x4ay7XYe/F3jjbf8GZS4hLFpzM8wIaKYShRpproL8Irq/4LW5tyhuFrsEkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/arrow-right.png
// module id = /K/t
// module chunks = 216